import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg-Icons _ Stepper _ Current",
  "use": "svg-Icons _ Stepper _ Current-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 20 20\" id=\"svg-Icons _ Stepper _ Current\"><circle cx=\"10\" cy=\"10\" r=\"9\" stroke=\"currentColor\" stroke-width=\"2\" /><circle cx=\"10\" cy=\"10\" r=\"4\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol